
export function translatePageName(page) {
  if (page === 'websiteProducts') {
    page = 'product websites'
  }

  const result = (page || '').replace(/([A-Z])/g, " $1").toLowerCase();
  page = result[result.length - 1] === 's' ? result.substring(0, result.length-1) : result

  return {
    'product': "producten",
    'attribute': 'attribuut',
    'brand': 'merk',
    'editor-package': 'editor pakket',
    'categorie': 'categorie',
    'discount': 'korting',
    'synonyms': 'synoniemen',
    'product website': 'productwebsite',
    'supplier': 'leverancier',
    'user': 'account',
    'website': 'website',

    'website file': 'website bestand',
    'product file': 'product bestand',
  }[page] || page
}
